import AddIcon from '@mui/icons-material/Add';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import ThemedButton from '../components/button/ThemedButton';
import GridContainer from '../components/container/GridContainer';
import ReportsTabs from '../components/reportsTabs/ReportsTabs';
import { useStore } from '../store/context';

import AddReportModal from '../components/dialog/AddReportsModal';

const DamageReport = observer((): JSX.Element => {
  const { welcomeStore } = useStore();
  const [modalState, setModal] = useState(false);
  const [reportsKey, setReportsKey] = useState(0);
  const navigate = useNavigate();

  const { currentEstate } = welcomeStore;

  const welcomeData = welcomeStore.getWelcomeData();

  const addReportButton = () => (
    <Box m={3}>
      <ThemedButton
        label="Neue Schadensmeldung"
        onClick={() => {
          setModal(true);
          navigate('?addCamera=true'); // Add query parameter to URL
        }}
        endIcon={<AddIcon />}
      />
    </Box>
  );

  const handleCloseModal = () => {
    setModal(false);
    setReportsKey(prevKey => prevKey + 1); // Force re-render of ReportsTabs
    navigate('?');
  };

  return (
    <Box width="100%">
      <GridContainer subheader={addReportButton()}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} p={{ xs: 0, md: 2 }} ml={{ lg: 2 }}>
            {currentEstate?.customerId && (
              <ReportsTabs key={reportsKey} currentEstate={currentEstate} />
            )}
            {modalState && (
              <AddReportModal
                onClose={handleCloseModal}
                open={modalState}
                customerId={Number(currentEstate?.customerId)}
                objId={Number(currentEstate?.objId)}
                user={welcomeData?.userData}
              />
            )}
          </Grid>
        </Grid>
      </GridContainer>
    </Box>
  );
});

export default DamageReport;
